import { LucideIcon } from 'lucide-react';
import { Button } from './Button';

/**
 * Empty State Component per UX Spec page 4
 * - Dashed border
 * - Tool-colour circle with dot icon
 * - Title (12px/500) + description (11px/muted)
 * - Single primary CTA centred
 * - Used when data panel has no records yet
 * - Never a blank white area
 */

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

export function EmptyState({ icon: Icon, title, description, action, className = '' }: EmptyStateProps) {
  return (
    <div className={`border-2 border-dashed border-gray-300 rounded-card p-12 text-center ${className}`}>
      <div className="w-12 h-12 rounded-full border-2 border-t1-primary bg-t1-light mx-auto mb-4 flex items-center justify-center">
        <Icon className="w-6 h-6 text-t1-primary" />
      </div>
      <h3 className="text-heading text-gray-900 mb-2">{title}</h3>
      <p className="text-label text-gray-600 mb-6">{description}</p>
      {action && (
        <Button onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );
}
